import { Component, Input } from '@angular/core'
import { DynamicImageWidget } from 'htv-lib'
import { BaseWidgetComponent } from '../base-widget/base-widget.component'

@Component({
  selector: 'app-dynamic-image-widget',
  standalone: true,
  imports: [],
  templateUrl: './dynamic-image.component.html',
  styleUrls: ['./dynamic-image.component.scss'],
})
export class DynamicImageComponent extends BaseWidgetComponent {
  @Input() url!: string

  override enableVisibilityControl = true

  constructor() {
    super()
  }

  override applyStyles(): void {
    super.applyStyles()

    const config = this.config as DynamicImageWidget
    const imageStyle: Record<string, string | number> = {}

    if (config.objectFit) {
      imageStyle['object-fit'] = config.objectFit
    }

    if (config.alignment) {
      imageStyle['object-position'] = config.alignment
    }

    this.setRule('.image', imageStyle)
  }
}
